import { useContext } from "react";
import { CheckoutContext } from "./context";

export const useCheckoutContextProvider = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error("No CheckoutContext context was provided.");
  }
  return context;
};
